export const HeaderSub = ({ className = "", header = "", text = "" }) => {
  return (
    <div className={`flex flex-col gap-6 ${className}`}>
      <p className="text-sm md:text-base lg:text-lg text-primary font-medium">
        {header}
      </p>
      <p className="text-grey-900 text-[32px] leading-[42px] lg:text-[48px] lg:leading-[60px] font-medium">
        {text}
      </p>
    </div>
  );
};
